import type { ComponentProps } from "react";
import { Link } from "react-router";

import { cn } from "@/utils/tailwind";

import { Logo } from "./logo";

interface LogoWithTitleProps extends Omit<ComponentProps<typeof Link>, "to"> {
  linkTo?: string;
}

export function LogoWithTitle({
  className,
  linkTo,
  ...props
}: LogoWithTitleProps) {
  const content = (
    <>
      <span className="bg-primary text-primary-foreground grid size-8 rotate-[-4deg] place-items-center rounded-lg shadow-sm">
        <Logo className="size-4" />
      </span>
      <span className="font-serif text-base font-semibold tracking-tight">
        {publicEnv.siteTitle}
      </span>
    </>
  );

  const baseClass = cn("flex items-center gap-2.5", className);

  return linkTo ? (
    <Link className={baseClass} to={linkTo} {...props}>
      {content}
    </Link>
  ) : (
    <div className={baseClass}>{content}</div>
  );
}
